import React from "react";
import "./MerchantDashboard.css";
import PayoutChart from "./PayoutChart";

function ThirdSection({ payoutStatistic}) {
  return (
    <div>
      <div className="second-section">
        <div className="settlement-wallet box-back">
          <div>
            <p className="wallet-head heading-new">Payout Breakup</p>
            <p className="sub-heading-new">
              {" "}
              ₹{" "}
              {payoutStatistic
                ? payoutStatistic?.payout?.payoutAmount
                  ? Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(payoutStatistic?.payout?.payoutAmount)
                  : "0.00"
                : "0.00"}
            </p>
          </div>

          <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Withdrawal Amount:</span>
              <span className="price ">
                {" "}
                ₹{" "}
                {payoutStatistic
                  ? payoutStatistic?.payout?.payoutAmount
                    ? Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(payoutStatistic?.payout?.payoutAmount)
                    : "0.00"
                  : "0.00"}
              </span>
            </p>
          </div>
          <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Commission :</span>

              <span className="price ">
                {" "}
                ₹{" "}
                {payoutStatistic
                  ? payoutStatistic?.payout?.payoutTotalComission
                    ? Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(payoutStatistic?.payout?.payoutTotalComission)
                    : "0.00"
                  : "0.00"}
              </span>
            </p>
          </div>
          <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Initiate  :</span>

              <span className="price">
                {" "}
                - ₹{" "}
                {payoutStatistic
                  ? payoutStatistic?.payout?.Initiate
                    ? Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(payoutStatistic?.payout?.Initiate || 0)
                    : "0.00"
                  : "0.00"}
              </span>
            </p>
          </div>
          <div className="normal-section  line-data">
            <p className="normal-font">
              <span className="">Net Payout :</span>
              <span className="price">
                {" "}
                ₹{" "}
                {payoutStatistic
                  ? payoutStatistic?.payout?.payoutSettlementAmount
                    ? Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(payoutStatistic?.payout?.payoutSettlementAmount)
                    : "0.00"
                  : "0.00"}
              </span>
            </p>
          </div>
        </div>

        <div className="chart-div settlement-wallet box-back">
          <PayoutChart payoutStatistic={payoutStatistic} />
        </div>
      </div>
    </div>
  );
}

export default ThirdSection;
